import api from "./api";

// 活动列表
export const activityList = params => {
  return api("post", `/v1/management/activity/list`, params);
};
// 新增活动
export const addActivity = params => {
  return api("post", `/v1/management/activity/addActivity`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
// 二维码
export const getActivityCode = params => {
  return api("get", `/v1/management/activity/qrcode/${params}`, { hideLoading: true });
};
// 删除活动
export const deleteActivity = (params, config) => {
  return api("get", `/v1/management/activity/deleteActivity`, params, config);
};
// 导出报名名单
export const exportEnrollmentList = activityId => {
  return api(
    "get",
    `/v1/management/activity/exportEnrollmentList/${activityId}`,
    {},
    {
      responseType: "blob",
    }
  );
};
// 导出组队报名名单
export const exportEnrollmentTeamList = activityId => {
  return api(
    "get",
    `/v1/management/activity/exportEnrollmentTeamList/${activityId}`,
    {},
    {
      responseType: "blob",
    }
  );
};
// 导出身份证信息名单
export const exampleExportTheIDCardInformationTable = activityId => {
  return api(
    "get",
    `/v1/management/activity/exampleExportTheIDCardInformationTable/${activityId}`,
    {},
    {
      responseType: "blob",
    }
  );
};
// 发布活动
export const releaseActivities = params => {
  return api("get", `/v1/management/activity/releaseActivities`, params);
};
// 专题活动发布活动
export const releaseThemaActivities = params => {
  return api("get", `/v1/management/activity/releaseThematicActivities`, params);
};
// 开放报名
export const openRegistration = params => {
  return api("get", `/v1/management/activity/openRegistration`, params);
};
// 活动标签
export const getActivityTag = params => {
  return api("get", `/v1/management/activity/activityTag`, params);
};
// 活动审核
export const postActivityCheck = params => {
  return api("post", `/v1/management/activity/activityCheck`, params);
};
// 下拉数据
export const activitySelect = () => {
  return api("get", `/v1/management/activity/activitySelect`);
};
// 详情
export const activityDetails = activityId => {
  return api("get", `/v1/management/activity/activityDetails/${activityId}`);
};
// 城市所属店铺查询
export const addressOfCityById = cityId => {
  return api("get", `/v1/management/activity/addressOfCity/${cityId}`, {}, { hideLoading: true });
};
// 查询活动状态
export const activityStatusById = activityId => {
  return api(
    "get",
    `/v1/management/activity/activityStatus/${activityId}`,
    {},
    { hideLoading: true }
  );
};

// 虚拟券码相关接口
// 虚拟券码列表
export const virtualExchangeCodeList = params => {
  return api("post", `/v1/management/virtual-exchange-code/list`, params);
};
// 删除虚拟券码
export const deleteVoucher = activityId => {
  return api("get", `/v1/management/virtual-exchange-code/deleteVoucher/${activityId}`);
};
// 虚拟兑换码导入
export const exportvirtualExchangeCode = params => {
  return api("post", `/v1/management/virtual-exchange-code/virtual-exchange-code`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
// 编辑虚拟券码
export const editVoucher = params => {
  return api("post", `/v1/management/virtual-exchange-code/editVoucher`, params);
};
// 下拉框数据
export const virtualExchangeCodeSelect = activityName => {
  return api("get", `/v1/management/virtual-exchange-code/activitySelect/${activityName}`);
};

// 店铺
// 店铺列表
export const addressList = params => {
  return api("post", `/v1/management/address/list`, params);
};
// 新增店铺
export const addAddress = params => {
  return api("post", `/v1/management/address/addAddress`, params);
};
// 店铺详情
export const addressDetails = addressId => {
  return api("get", `/v1/management/address/addressDetails/${addressId}`);
};

// 删除店铺
export const deleteAddress = addressId => {
  return api("get", `/v1/management/address/deleteAddress/${addressId}`);
};

// 专题活动
// 专题活动列表
export const postThemActivityList = params => {
  return api("post", "/v1/management/activity/thematicActivities", params);
};

// 新增/编辑专题活动
export const postAddThemActivity = params => {
  return api("post", "/v1/management/activity/addThematicActivities", params);
};

// 查看专题活动
export const getThemActivityDetail = params => {
  return api("get", `/v1/management/activity/thematicActivitiesDetails/${params}`);
};

// 高光时刻
// 高光时刻列表
export const postMemberList = params => {
  return api("post", "/v1/management/highlight-moment/list", params);
};

// 查看高光时刻详情
export const getHighlightMomentDetails = (objectType, objectId) => {
  return api("get", `/v1/management/highlight-moment/HighlightMomentDetails/${objectType}/${objectId}`);
};

// 删除高光时刻照片
export const deleteHighlightMoment = (objectType, objectId) => {
  return api("get", `/v1/management/highlight-moment/deleteHighlightMoment/${objectType}/${objectId}`);
};
// 新增/编辑UaStar
export const updateHighlightMoment = params => {
  return api("post", "/v1/management/highlight-moment/updateHighlightMoment", params);
};

// 批量导入uastar活动
export const uploadUaStarList = params => {
  return api("post", "/v1/management/activity/uploadUaStarList", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// 新增/编辑专题活动
export const updateSpecialHighlightMoment = params => {
  return api("post", "/v1/management/highlight-moment/updateSpecialHighlightMoment", params);
};

// 活动带参链接二维码分享下拉框数据
export const buriedChannelSelect = params => {
  return api("get", "/v1/management/activity/buriedChannelSelect", params);
};

// 导出固定时限的报名签到名单
export const exportFixedTimeEnrollmentList = params => {
  return api("post", "/v1/management/activity/exportFixedTimeEnrollmentList", params,
    {
      responseType: "blob",
    });
};

// 活动分享带参
export const buriedChannel = params => {
  return api("post", "/v1/management/activity/buriedChannel", params);
};

// 活动Channel-Source关联
export const buriedChannelSelectTwoStageLinkage = params => {
  return api("post", "/v1/management/activity/buriedChannelSelectTwoStageLinkage", params);
};

// 获取Campaign
export const buriedChannelCampaign = params => {
  return api("post", "/v1/management/activity/buriedChannelCampaign", params);
};

// 活动聚合页面列表
export const postAggregation = params => {
  return api("post", `/v1/management/activity/exclusiveActivityAggregationPageList`, params);
};
// 活动聚合页面新增
export const addAggregation = params => {
  return api("post", `/v1/management/activity/exclusiveActivityAggregationPageAdd`, params);
};
// 活动聚合页面编辑
export const updateAggregation = params => {
  return api("post", `/v1/management/activity/exclusiveActivityAggregationPageUpdate`, params);
};
// 活动聚合页面详情
export const fetchAggregationDetail = params => {
  return api("get", `/v1/management/activity/exclusiveActivityAggregationPageDetails/${params}`);
};

// 活动聚合页面搜索数据
export const searchActionById = params => {
  return api("get", `/v1/management/activity/taskUaEventSelect/${params}`);
};

// 专题活动相册发布
export const publishSpecialHighlightMoment = id => {
  return api("get", `/v1/management/highlight-moment/publishSpecialHighlightMoment/${id}`);
};

// 专题活动相册下架
export const soldOutSpecialHighlightMoment = id => {
  return api("get", `/v1/management/highlight-moment/soldOutSpecialHighlightMoment/${id}`);
};

// 专题活动相册新增
export const addSpecialHighlightMoment = params => {
  return api("post", `/v1/management/highlight-moment/addSpecialHighlightMoment`, params);
};

// 专题活动相册修改
export const updateHighlightMomentOfSpecial = params => {
  return api("post", `/v1/management/highlight-moment/updateHighlightMomentOfSpecial`, params);
};

// 专题活动相册删除
export const deleteSpecialHighlightMoment = id => {
  return api("get", `/v1/management/highlight-moment/deleteSpecialHighlightMoment/${id}`);
};

// 专题活动相册详情
export const specialHighlightMomentDetails = id => {
  return api("get", `/v1/management/highlight-moment/specialHighlightMomentDetails/${id}`,);
};
